<template>
    <div>
      <h2>Vidéothèque</h2>
      <p>Ici seront placées les différentes vidéos ainsi que les fonctions de tri...</p>
    </div>
</template>

<script>
export default {
	name: "VideoLibrary",
};
</script>

<style scoped>

</style>
